import React from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import { articles } from '../articles';
import './BlogIndex.css';

const BlogIndex = () => {
  return (
    <div className="blog-index-container">
      <Helmet>
        <title>두바이 쫀득쿠키 이야기 - 블로그</title>
        <meta name="description" content="두바이 쿠키의 역사, 재료, 레시피 등 다양하고 흥미로운 디저트 이야기를 만나보세요." />
      </Helmet>
      <h1>블로그</h1>
      <p>두바이 쫀득쿠키와 디저트에 대한 흥미로운 이야기들을 만나보세요.</p>
      <div className="article-list">
        {articles.map((article, index) => (
          <Link to={`/blog/${article.slug}`} key={index} className="article-card">
            <h2>{article.title}</h2>
            <p>{article.summary}</p>
            <span className="read-more">더 읽어보기</span>
          </Link>
        ))}
      </div>
    </div>
  );
};

export default BlogIndex;
